import { HStack, Text } from '@gluestack-ui/themed';
import { Link } from 'react-router-dom';
import { AppIcon } from '../AppIcon/AppIcon';

export interface BreadcrumbItem {
  readonly label: string;
  readonly to?: string;
}

export interface BreadcrumbsProps {
  readonly items: readonly BreadcrumbItem[];
}

/** Compact hierarchical navigation for detail and workflow pages. */
export function Breadcrumbs({ items }: BreadcrumbsProps): React.JSX.Element | null {
  if (items.length === 0) return null;

  return (
    <HStack
      role="navigation"
      aria-label="Breadcrumb"
      alignItems="center"
      space="xs"
      flexWrap="wrap"
      flexShrink={0}
    >
      {items.map((item, index) => {
        const current = index === items.length - 1;

        return (
          <HStack key={`${item.label}-${String(index)}`} alignItems="center" space="xs">
            {index === 0 ? null : (
              <Text color="$textLight400" $dark-color="$textDark600" aria-hidden="true">
                <AppIcon name="chevronRight" size={14} />
              </Text>
            )}
            {current || item.to === undefined ? (
              <Text
                size="xs"
                bold={current}
                color={current ? '$textLight700' : '$textLight500'}
                $dark-color={current ? '$textDark200' : '$textDark500'}
                aria-current={current ? 'page' : undefined}
              >
                {item.label}
              </Text>
            ) : (
              <Link to={item.to} style={{ textDecoration: 'none' }}>
                <Text size="xs" color="$primary600" $dark-color="$primary400">
                  {item.label}
                </Text>
              </Link>
            )}
          </HStack>
        );
      })}
    </HStack>
  );
}
